// extracted by mini-css-extract-plugin
export default {"tabsItems":"productArchive_tabsItems__qi3vR","tabBtn":"productArchive_tabBtn__TzKAA","addBtn":"productArchive_addBtn__u8x3J"};